
import { Component, Watch, Vue } from 'vue-property-decorator';
import CommonFooter from './CommonFooter.vue';
import store from '@/store';
// @ is an alias to /src

@Component({
  components: {
    CommonFooter
  }
})
export default class CommonFooterEn extends Vue {
  private name = 'CommonFooterEn';
  get lang(): string {
    return store.getters['auth/lang'];
  }
  get isLogin(): boolean {
    return !!store.getters['auth/token'];
  }
}
